import { ICustomColumn } from '../../../common/types/commonTypes';
import { PartRequestBulkItemDto } from '../types';
import { BulkRequestTypeEnum } from '../BulkRequestTypeEnum';

export type ColDef = Pick<ICustomColumn, 'title' | 'dataIndex' | 'filterSearch'> & {
  dataIndex: keyof PartRequestBulkItemDto;
};

const No: ColDef = { title: 'No', dataIndex: 'ordinalNumber' };
const Location: ColDef = { title: 'Location', dataIndex: 'location' };
const Owner: ColDef = { title: 'Owner', dataIndex: 'ownerId' };
const Customer: ColDef = { title: 'Customer', dataIndex: 'customerName' };
const LinkedTo: ColDef = { title: 'Linked to', dataIndex: 'linkedEntityNumber', filterSearch: true };
const ProductNo: ColDef = { title: 'Product No', dataIndex: 'productNumber', filterSearch: true };
const ProductName: ColDef = { title: 'Product name', dataIndex: 'productName' };
const Qty: ColDef = { title: 'Qty', dataIndex: 'requestedQuantity' };
const PurchaseOrderQty: ColDef = { title: 'Qty', dataIndex: 'purchaseOrderGenerationQuantity' };
const CostPrice: ColDef = { title: 'Cost Price', dataIndex: 'costPrice' };

const AvailableInStock: ColDef = { title: 'Available in Stock', dataIndex: 'availableInStock' };
const Supplier: ColDef = { title: 'Supplier', dataIndex: 'suppliers' };
const Pricelist: ColDef = { title: 'Pricelist', dataIndex: 'pricelists' };
const Allocated: ColDef = { title: 'Allocated', dataIndex: 'allocatedQuantity' };
const Ready: ColDef = { title: 'Ready', dataIndex: 'readyQuantity' };
const Collected: ColDef = { title: 'Collected', dataIndex: 'collectedQuantity' };

export const getColumns = (bulkOperationType: BulkRequestTypeEnum | null): ColDef[] => {
  switch (bulkOperationType) {
    case BulkRequestTypeEnum.MarkAsCollected:
      return [No, Customer, LinkedTo, ProductNo, ProductName, Qty, CostPrice, Owner];
    case BulkRequestTypeEnum.MarkAsReady:
      return [No, Customer, LinkedTo, ProductNo, ProductName, Qty, CostPrice, Location];
    case BulkRequestTypeEnum.ReviewStockSource:
      return [No, Customer, LinkedTo, ProductNo, ProductName, Qty, AvailableInStock];
    case BulkRequestTypeEnum.ReviewPricelistSource:
      return [No, Customer, LinkedTo, ProductNo, ProductName, Qty, CostPrice, Supplier, Pricelist];
    case BulkRequestTypeEnum.ReturnToStock:
      return [No, Customer, LinkedTo, ProductNo, ProductName, Qty, Allocated, Ready, Collected];
    case BulkRequestTypeEnum.GeneratePurchaseOrder:
      return [No, Customer, LinkedTo, ProductNo, ProductName, PurchaseOrderQty, CostPrice];
    default:
      return [];
  }
};

export const isSelectionDisabled = (bulkOperationType: BulkRequestTypeEnum | null, row: PartRequestBulkItemDto): boolean => {
  if (bulkOperationType !== BulkRequestTypeEnum.ReviewStockSource) {
    return false;
  }

  return !row.isReviewStockSourceLineSelectable;
};
